// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorWrapper_wrapper__E1LV0"};